import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { getFormattedVersionDate } from '../../../common/utils.tsx';

type Props = {
	releaseDate: string;
	overdue: boolean;
};

export const ReleaseDateCell = ({ releaseDate, overdue }: Props): React.JSX.Element => {
	const { formatDate } = useIntl();

	return (
		<Box xcss={[releaseDateCellStyles, overdue && overdueReleaseDateCellStyles]}>
			{getFormattedVersionDate(releaseDate, formatDate)}
		</Box>
	);
};

const releaseDateCellStyles = xcss({
	wordWrap: 'break-word',
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
});

const overdueReleaseDateCellStyles = xcss({
	color: 'color.text.danger',
});
